import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { AuthingButton } from "../../../components/AuthingButton";
import { Link } from "../../../components/LinkIcon";
import { tryNow } from "../../../utils";
import "./styles.less";

export const ZeroTrustBanner = (props) => {
  const { t } = useTranslation();

  return (
    <div>
      <section className="zero-trust-banner">
        <div className="zero-trust-banner-container ">
          <div className="banner-title">{t("zeroTrust.banner.title")}</div>
          <div className="subtitle">{t("zeroTrust.banner.subtitle")}</div>

          <AuthingButton
            style={{ marginRight: 24, fontSize: 18 }}
            mode="light"
            onClick={() => {
              window.open(
                "https://www.authing.cn/authingform?fromTag=零信任落地页01"
              );
            }}
          >
            {t("common.button.consult")}
          </AuthingButton>

          <Link
            style={{ color: "#fff", fontSize: 18, padding: "0 24px" }}
            iconSize={24}
            onClick={tryNow}
          >
            {t("common.button.try-now")}
          </Link>
        </div>
      </section>
    </div>
  );
};
